import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { of } from 'rxjs';

import { RenderSetupDataService } from 'idt-ecommerce-api/render-setup-data/render-setup-data.service';
import { EcommerceUrlResolverService } from 'idt-ecommerce-api/shared/url-resolver/ecommerce-url-resolver.service';
import { EccomerceApiRoutes } from 'idt-ecommerce-api/shared/url-resolver/resources/eccomerce-api.routes';

import type { StorefrontMenu, StorefrontMenuItemDetailList } from './api-navigation-storefront.models';
import type { Observable } from 'rxjs';


export interface StorefrontMenuParams {
  language: string;
  catalogId?: number;
}

export interface StorefrontMenuItemDetailsParams {
  language: string;
  itemId?: string;
  seoId?: number;
  catalogId?: number;
}

@Injectable({ providedIn: 'root' })
export class ApiNavigationStorefrontService {

  private readonly http = inject(HttpClient);
  private readonly urlResolver = inject(EcommerceUrlResolverService);
  private readonly renderSetupDataService = inject(RenderSetupDataService);

  public getMenu(storeId: string, params: StorefrontMenuParams): Observable<StorefrontMenu> {
    if (this.renderSetupDataService.menuItems) {
      return of(this.renderSetupDataService.menuItems);
    }

    const storedItems = sessionStorage.getItem('storefrontMenuItems');
    if (storedItems) {
      return of(JSON.parse(storedItems) as StorefrontMenu);
    }

    const url = this.urlResolver.resolveStorefrontAPI(1, EccomerceApiRoutes.STOREFRONT_MENU, storeId);
    return this.http.get<StorefrontMenu>(url, { params: this.buildMenuParams(params) });
  }

  public getMenuItemDetails(
    storeId: string,
    params: StorefrontMenuItemDetailsParams
  ): Observable<StorefrontMenuItemDetailList> {
    const url = this.urlResolver.resolveStorefrontAPI(1, EccomerceApiRoutes.STOREFRONT_MENU_ITEMS, storeId);
    return this.http.get<StorefrontMenuItemDetailList>(url, { params: this.buildMenuItemDetailsParams(params) });
  }

  private buildMenuParams(params: StorefrontMenuParams): HttpParams {
    let httpParams = new HttpParams().set('language', params.language);
    if (params.catalogId != null) {
      httpParams = httpParams.set('catalogId', params.catalogId);
    }
    return httpParams;
  }

  private buildMenuItemDetailsParams(params: StorefrontMenuItemDetailsParams): HttpParams {
    let httpParams = new HttpParams().set('language', params.language);
    if (params.itemId != null) {
      httpParams = httpParams.set('itemId', params.itemId);
    }
    if (params.seoId != null) {
      httpParams = httpParams.set('seoId', params.seoId);
    }
    if (params.catalogId != null) {
      httpParams = httpParams.set('catalogId', params.catalogId);
    }
    return httpParams;
  }

}
